import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/3dots.svg'


const _hoisted_1 = { class: "header withShadow d-flex aling-items-center justify-content-between py-2" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "smallChatHeaderUserImage me-2" }
const _hoisted_5 = { class: "fs_12 greyBlue d-block ln_12" }
const _hoisted_6 = {
  key: 0,
  src: _imports_1
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_3
      ]),
      (_ctx.hasUserInfo)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "d-flex align-items-center ms-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openDetail')))
          }, [
            _withDirectives(_createVNode("div", _hoisted_4, null, 512), [
              [_directive_userimage, _ctx.$store.state.getUserImage(_ctx.userIdentifier)]
            ]),
            _createVNode("div", null, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.userName), 1),
              _createVNode(_component_localized_text, {
                class: "text-decoration-underline pointer fs_10 greyBlue d-block ln_12",
                localizedKey: "app_toccaPerInfo",
                text: "Tocca per info"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", {
      class: "sideContainer",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('settingsModal')))
    }, [
      (_ctx.hasOptions)
        ? (_openBlock(), _createBlock("img", _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}